export default "<div class=\"loading\">\n  <i class=\"fas fa-spinner fa-pulse fa-4x\"></i>\n  Ładuję...\n</div>\n";